// extracted by mini-css-extract-plugin
export var callCard = "_p6-0";
export var callMessageButton = "_p6-1";
export var helpIcon = "_p6-3";
export var helpIconContainer = "_p6-4";
export var verticalDivider = "_p6-2";